module.exports = __webpack_public_path__ + "79df5596d7097b1dd2fd4d5f849d22f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/ybicons/iconfont.ttf?t=1584093387977
// module id = 1225
// module chunks = 3